import dayjs from 'dayjs'
import dayjsPluginUTC from 'dayjs-plugin-utc'
import relativeTime from 'dayjs/plugin/relativeTime'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import duration from 'dayjs/plugin/duration'

dayjs.extend(dayjsPluginUTC)
dayjs.extend(relativeTime)
dayjs.extend(duration)
dayjs.extend(isSameOrBefore)

export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, '$dates', { value: dayjs })
  }
}
